"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateIntegrationData = exports.generateNotificationData = exports.generateStreamData = exports.generateScriptData = exports.generateHttpRequestData = exports.generateTransformationData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const integrations_1 = require("./../types/integrations");
const generateColumns = () => {
    const columns_nb = en_1.faker.number.int({
        min: 1,
        max: 3,
    });
    let columns = [];
    for (let i = 0; i < columns_nb; i++) {
        columns.push({
            column_name: en_1.faker.word.words(1),
            column_type: en_1.faker.helpers.arrayElement(Object.values(types_1.PostgresTypes)),
        });
    }
    return columns;
};
const generateTransformationData = (transformation = {}) => {
    return {
        id: transformation.id || (0, tools_1.IDSource)(),
        title: transformation.title || en_1.faker.word.words(5),
        db_type: transformation.db_type || types_1.TRANSFORMATION_DB_TYPE.POSTGRES,
        query: transformation.query || en_1.faker.word.words(10),
        primary_key: transformation.primary_key || "id",
        backtrack_offset: transformation.backtrack_offset || 0,
        add_data_strategy: transformation.add_data_strategy ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.ADD_DATA_STRATEGY)),
        transformation_aggregation_period: transformation.transformation_aggregation_period ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.TRANSFORMATION_AGGREGATION_PERIOD)),
        destination_columns: transformation.destination_columns || generateColumns(),
    };
};
exports.generateTransformationData = generateTransformationData;
const generateHttpRequestData = (http_request = {}) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        id: (_a = http_request.id) !== null && _a !== void 0 ? _a : (0, tools_1.IDSource)(),
        name: (_b = http_request.name) !== null && _b !== void 0 ? _b : en_1.faker.word.words(5),
        body: (_c = http_request.body) !== null && _c !== void 0 ? _c : en_1.faker.word.words(1),
        url: (_d = http_request.url) !== null && _d !== void 0 ? _d : en_1.faker.internet.url(),
        method: (_e = http_request.method) !== null && _e !== void 0 ? _e : en_1.faker.helpers.arrayElement(Object.values(types_1.HTTP_REQUEST_METHOD)),
        created_at: (_f = http_request.created_at) !== null && _f !== void 0 ? _f : new Date(),
        created_by: (_g = http_request.name) !== null && _g !== void 0 ? _g : "SYSTEM",
    };
};
exports.generateHttpRequestData = generateHttpRequestData;
const generateScriptData = (script = {}) => {
    return {
        id: script.id || (0, tools_1.IDSource)(),
        title: script.title || en_1.faker.word.words(5),
        response_schema: script.response_schema || [],
        script: script.script || "",
        script_language: script.script_language || types_1.SCRIPT_LANGUAGE.JAVASCRIPT,
        result_format: types_1.SCRIPT_RESULT_FORMAT.CSV,
    };
};
exports.generateScriptData = generateScriptData;
const generateStreamData = (stream = {}) => {
    return {
        id: stream.id || (0, tools_1.IDSource)(),
        add_data_strategy: stream.add_data_strategy ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.ADD_DATA_STRATEGY)),
        columns: stream.columns || [
            {
                destination_name: "id",
                origin_name: "id",
                type: "string",
            },
        ],
        destination_table: stream.destination_table || "destination",
        primary_key: stream.primary_key || "id",
    };
};
exports.generateStreamData = generateStreamData;
const generateNotificationData = (notification = {}) => {
    let web_users = notification.web_users;
    let queries = notification.queries;
    if (!web_users) {
        let web_usersNb = en_1.faker.number.int({
            min: 1,
            max: 5,
        });
        web_users = [];
        for (let i = 0; i < web_usersNb; i++) {
            web_users.push((0, tools_1.IDSource)());
        }
    }
    if (!queries) {
        let queriesNb = en_1.faker.number.int({
            min: 0,
            max: 3,
        });
        queries = [];
        for (let i = 0; i < queriesNb; i++) {
            queries.push({
                name: en_1.faker.word.words(2),
                query: en_1.faker.helpers.arrayElement(getQueries()),
            });
        }
    }
    return {
        id: notification.id || (0, tools_1.IDSource)(),
        body: notification.body || en_1.faker.word.words(5),
        title: notification.title || en_1.faker.word.words(3),
        type: notification.type ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.NOTIFICATION_TYPE)),
        db_type: notification.db_type ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.NOTIFICATION_DB_TYPE)),
        queries: notification.queries || queries,
        web_users: notification.web_users || web_users,
        date_range: notification.date_range ||
            en_1.faker.helpers.arrayElement(Object.values(types_1.NOTIFICATION_DATE_RANGE)),
    };
};
exports.generateNotificationData = generateNotificationData;
const getQueries = () => {
    let queries = ["SELECT 5 ;", "SELECT 100;", "SELECT 500;", "SELECT 1000;"];
    return queries;
};
const generateIntegrationData = (integration = {}) => {
    let type = integration.type;
    let currency_mapping = [];
    let fields_mapping = [];
    if (!type)
        type = en_1.faker.helpers.arrayElement(Object.values(types_1.INTEGRATION_TYPE));
    const fields_mapping_nb = en_1.faker.number.int({
        min: 0,
        max: 3,
    });
    fields_mapping = [];
    for (let i = 0; i < fields_mapping_nb; i++) {
        fields_mapping.push({
            origin_variable: en_1.faker.word.words(1),
            destination_variable: en_1.faker.word.words(1),
        });
    }
    if (type === types_1.INTEGRATION_TYPE.BEYONIC) {
        const currency_mapping_nb = en_1.faker.number.int({
            min: 0,
            max: 3,
        });
        currency_mapping = [];
        for (let i = 0; i < currency_mapping_nb; i++) {
            currency_mapping.push({
                currency: en_1.faker.helpers.arrayElement(Object.keys(integrations_1.BEYONIC_CURRENCIES)),
                account_id: en_1.faker.string.numeric(10),
            });
        }
    }
    let integ = {
        id: integration.id || (0, tools_1.IDSource)(),
        title: integration.title || en_1.faker.word.words(3),
        type: integration.type || type,
        url: integration.url || en_1.faker.internet.url(),
        api_key: integration.api_key || en_1.faker.string.alphanumeric(10),
        fields_mapping: [],
        created_at: integration.created_at || new Date(),
        destination_table: integration.destination_table || en_1.faker.database.collation(),
        webhooks: integration.webhooks || [],
        created_by: integration.created_by ||
            `${en_1.faker.person.firstName} ${en_1.faker.person.lastName}`,
        edited_at: integration.edited_at || new Date(),
        edited_by: integration.edited_by ||
            `${en_1.faker.person.firstName} ${en_1.faker.person.lastName}`,
    };
    if (integration.currency_mapping || currency_mapping.length > 0) {
        integ = Object.assign(Object.assign({}, integ), { currency_mapping: integration.currency_mapping || currency_mapping });
    }
    return integ;
};
exports.generateIntegrationData = generateIntegrationData;
